export enum CivilLawCostsOfIncomeType {
  Normal = 0,
  Increased = 1,
  None = 2,
}
